import { render } from "./CategoryFreeShipping.vue?vue&type=template&id=3b4bea70"
import script from "./CategoryFreeShipping.vue?vue&type=script&lang=js"
export * from "./CategoryFreeShipping.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__